import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../../src/component/admin/AdminLayout";

import {
  getRetreatTypeById,
  updateRetreatType,
} from "../../services/retreatTypeService";

export default function EditRetreatType() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    typeName: "",
    route: "",

    heroTitle: "",
    heroSubtitle: "",
    heroDescription: "",

    heroImage: "",
    highlightsImage: "",
    gainsImage: "",

    duration: "",
    level: "",

    brochureUrl: "",

    experienceHighlights: [""],
    gains: [""],
  });

  useEffect(() => {
    loadRetreatType();
  }, []);

  const loadRetreatType = async () => {
    try {
      const res = await getRetreatTypeById(id);

      setFormData({
        ...res.data,
        experienceHighlights:
          res.data.experienceHighlights?.length > 0
            ? res.data.experienceHighlights
            : [""],

        gains:
          res.data.gains?.length > 0
            ? res.data.gains
            : [""],
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleHighlightChange = (index, value) => {
    const updated = [...formData.experienceHighlights];
    updated[index] = value;

    setFormData({
      ...formData,
      experienceHighlights: updated,
    });
  };

  const handleGainChange = (index, value) => {
    const updated = [...formData.gains];
    updated[index] = value;

    setFormData({
      ...formData,
      gains: updated,
    });
  };

  const addHighlight = () => {
    setFormData({
      ...formData,
      experienceHighlights: [
        ...formData.experienceHighlights,
        "",
      ],
    });
  };

  const addGain = () => {
    setFormData({
      ...formData,
      gains: [...formData.gains, ""],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanTypeName = formData.typeName.trim();

    const payload = {
      ...formData,

      typeName: cleanTypeName,

      route: cleanTypeName
        .toLowerCase()
        .replace(/\s+/g, "-"),

      experienceHighlights:
        formData.experienceHighlights.filter(
          (item) => item.trim() !== ""
        ),

      gains: formData.gains.filter(
        (item) => item.trim() !== ""
      ),
    };

    try {
      await updateRetreatType(id, payload);

      alert("Retreat Type Updated Successfully");

      navigate("/admin/retreat-types");
    } catch (err) {
      console.error(err.response?.data || err);

      alert(
        err.response?.data?.message ||
          "Failed to update retreat type"
      );
    }
  };

  return (
    <AdminLayout>
      <h1 className="text-4xl font-bold mb-8">
        Edit Retreat Type
      </h1>

      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-2xl shadow space-y-5"
      >
        <input
          name="typeName"
          placeholder="Type Name"
          value={formData.typeName}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="heroTitle"
          placeholder="Hero Title"
          value={formData.heroTitle}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="heroSubtitle"
          placeholder="Hero Subtitle"
          value={formData.heroSubtitle}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <textarea
          name="heroDescription"
          rows={4}
          value={formData.heroDescription}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="heroImage"
          placeholder="Hero Image"
          value={formData.heroImage}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="highlightsImage"
          placeholder="Highlights Image"
          value={formData.highlightsImage}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="gainsImage"
          placeholder="Gains Image"
          value={formData.gainsImage}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="duration"
          placeholder="Duration"
          value={formData.duration}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="level"
          placeholder="Level"
          value={formData.level}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="brochureUrl"
          placeholder="Brochure URL"
          value={formData.brochureUrl}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <div className="border rounded p-4">
          <h3 className="font-bold mb-3">
            Experience Highlights
          </h3>

          {formData.experienceHighlights.map(
            (item, index) => (
              <input
                key={index}
                value={item}
                onChange={(e) =>
                  handleHighlightChange(
                    index,
                    e.target.value
                  )
                }
                className="w-full border p-3 rounded mb-2"
              />
            )
          )}

          <button
            type="button"
            onClick={addHighlight}
            className="bg-gray-200 px-4 py-2 rounded"
          >
            + Add Highlight
          </button>
        </div>

        <div className="border rounded p-4">
          <h3 className="font-bold mb-3">
            What You'll Gain
          </h3>

          {formData.gains.map((item, index) => (
            <input
              key={index}
              value={item}
              onChange={(e) =>
                handleGainChange(
                  index,
                  e.target.value
                )
              }
              className="w-full border p-3 rounded mb-2"
            />
          ))}

          <button
            type="button"
            onClick={addGain}
            className="bg-gray-200 px-4 py-2 rounded"
          >
            + Add Gain
          </button>
        </div>

        <button
          type="submit"
          className="bg-secondary text-white px-6 py-3 rounded-xl"
        >
          Update Retreat Type
        </button>
      </form>
    </AdminLayout>
  );
}